import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledHistoryContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
  textAlign: 'start',
  whiteSpace: 'pre',
});

export const StyledHistoryRow = styled(Box, {
  borderBottom: '1px solid $warmGray300',

  '&:last-child': {
    borderBottom: 'none',
  },
});

export const StyledHistoryEvent = styled(Box, {
  color: '$charcoal400',
  fontWeight: '$bold',
});

export const StyledHistoryDetails = styled(Box, {
  color: '$charcoal400',
  display: 'flex',
  gap: '$1',

  ':not(:last-of-type)': {
    marginBottom: '$4',
  },
});

export const StyledPagination = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
});

export const StyledNoDataAvailable = styled(Box, {
  alignItems: 'center',
  color: '$darkBlue400',
  display: 'flex',
  fontSize: '$xl',
  fontWeight: '$bold',
  lineHeight: '$8',
  margin: 'auto',
});
